import {Smile, PlusSquare, Binary, Hash, Globe, Network, FileCog} from "lucide-react"

const tools = [
        {
            "name": "Test01",
            "external": true,
            "url": "https://kevink.dev",
            "icon": Smile,
            "category": "osm",
            "hidden": true
        },
        {
            "name": "tools.cryptography.rot.title",
            "external": false,
            "urlname": "rot",
            "icon": PlusSquare,
            "category": "cryptography",
            "hidden": false,
            "keywords": "rot, rot-n, caesar, rotation, cryptography, encryption, decryption"
        },
        {
            "name": "tools.encodings.base64.title",
            "external": false,
            "urlname": "base64",
            "icon": Binary,
            "category": "encodings",
            "hidden": false,
            "keywords": "binary, base64, base, 64, encodings, encoding, decoding"
        },
        {
            "name": "tools.encodings.numberbase.title",
            "external": false,
            "urlname": "numberbase",
            "icon": Hash,
            "category": "encodings",
            "hidden": false,
            "keywords": "binary, base, base6, base10, base2, binary, hex, hexadecimal, oct, bin, dec, encodings, encoding, decoding"
        },
        {
            "name": "tools.encodings.urlencode.title",
            "external": false,
            "urlname": "urlencode",
            "icon": Globe,
            "category": "encodings",
            "hidden": false,
            "keywords": "URL, urlencode, urldecode, URI, uriencode, uridecode, encoding, decoding, encoder, decoder, tool"
        },
        {
            "name": "tools.networking.ipv4subnetting.title",
            "external": false,
            "urlname": "ipv4subnetting",
            "icon": Network,
            "category": "networking",
            "hidden": false,
            "keywords": "subnetting, networking, ipv4, ip4, ip, internet protocol, subnet, subnetter, netmask, tool"
        },
        {
            "name": "tools.encodings.linux_permissions.title",
            "external": false,
            "urlname": "linux_permissions",
            "icon": FileCog,
            "category": "encodings",
            "hidden": false,
            "keywords": "Linux, Permissions, octet, octets, rwx, encoding, decoding, encoder, decoder, calculator, umask, binary, tool"
        }
    ]

export default tools